import {
  FlexWidget,
  TextWidget,
  type WidgetRepresentation,
} from "react-native-android-widget";
import { darkColors, lightColors } from "~/styles/tokens";
import {
  computeCounterValue,
  describeCounterValue,
  formatDayCount,
} from "~/utils/dates";
import type { Counter } from "~/types";

type Palette = {
  ink: string;
  background: string;
  muted: string;
  accent: string;
};

function tile(counter: Counter | null, palette: Palette) {
  if (!counter) {
    return (
      <FlexWidget
        clickAction="OPEN_APP"
        style={{
          height: "match_parent",
          width: "match_parent",
          backgroundColor: palette.background as `#${string}`,
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <TextWidget
          text="+"
          style={{
            fontSize: 28,
            fontWeight: "700",
            color: palette.ink as `#${string}`,
          }}
        />
      </FlexWidget>
    );
  }

  const value = computeCounterValue(counter);
  const caption = describeCounterValue(counter.direction, value);
  const figureColor = counter.color === "red" ? palette.accent : palette.ink;

  return (
    <FlexWidget
      clickAction="OPEN_APP"
      style={{
        height: "match_parent",
        width: "match_parent",
        backgroundColor: palette.background as `#${string}`,
        paddingHorizontal: 6,
        paddingVertical: 8,
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {counter.label ? (
        <TextWidget
          text={counter.label}
          truncate="END"
          maxLines={1}
          style={{
            fontSize: 10,
            color: palette.muted as `#${string}`,
            textAlign: "center",
          }}
        />
      ) : null}
      <TextWidget
        text={formatDayCount(value.days)}
        style={{
          fontSize: 26,
          fontWeight: "700",
          color: figureColor as `#${string}`,
          textAlign: "center",
        }}
      />
      <TextWidget
        text={caption}
        truncate="END"
        maxLines={1}
        style={{
          fontSize: 8,
          color: (value.isPending
            ? palette.accent
            : palette.muted) as `#${string}`,
          textAlign: "center",
        }}
      />
    </FlexWidget>
  );
}

/** Builds both light and dark trees so Android's dynamic theming just works. */
export function buildDuranceWidget(
  counter: Counter | null,
): WidgetRepresentation {
  return {
    light: tile(counter, {
      ink: lightColors.ink,
      background: lightColors.background,
      muted: "#8a8a8a",
      accent: lightColors.accent,
    }),
    dark: tile(counter, {
      ink: darkColors.ink,
      background: darkColors.background,
      muted: "#8a8a8a",
      accent: darkColors.accent,
    }),
  };
}
